import { render } from "./companyDetailModal.vue?vue&type=template&id=72f7d162"
import script from "./companyDetailModal.vue?vue&type=script&lang=js"
export * from "./companyDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__